import React, { useEffect, useState } from "react";
import { Button, Card, Col, Input, Row, Select } from "antd";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { CgCloseO } from "react-icons/cg";
import { RiAddCircleFill } from "react-icons/ri";
import { age } from "./data";
import { toast } from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";

import "./Pets.css";

function Pets({ data }) {
  const [checked, setChecked] = useState(false);
  const [pets, setPets] = useState([
    { id: uuidv4(), name: "", type: "", weight: "", age: "" },
  ]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if(companyName){
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(
            db,
            "companies",
            companyName,
            "tenants"
          );
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label: doc.data().propertyGroupName,
            ...doc.data(),
          }));
          const filteredTenant = fetchedData.find((item)=> item.id === data?.id);
          setPets(filteredTenant?.pets?.length >= 1 ? filteredTenant?.pets : [{ id: 1, name: "", type: "", weight: "", age: "" }]);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
    }
  }, [companyName, checked]);

  const addPet = () => {
    const newPet = {
      id: uuidv4(),
      name: "", type: "", weight: "", age: ""
    };
    setPets([...pets, newPet]);
  };

  const removePet = (id) => {
    const updatedPet = pets.filter(
      (pet) => pet.id !== id
    );
    setPets(updatedPet);
  };

  const handleChange = (value, name, id) => {
    const updatedPet = pets.map((pet) => {
      if (pet.id === id) {
        return { ...pet, [name]: value };
      }
      return pet;
    });
    setPets(updatedPet);
  };

  const addPets = () => {
    try {
      const tenantRef = doc(
        db,
        "companies",
        companyName,
        "tenants",
        data?.id
      );
      const filteredPets = pets.filter((item) => {
        return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
      })
      const vehiclesObj = {
        "pets": filteredPets
      };
      updateDoc(tenantRef, vehiclesObj);
      setChecked(false);
      toast.success("Tenant pets info updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  // const addAnotherPet = () => {
  //   setPets([...pets, { petsName: "", type: "", weight: "", age: "" }]);
  // };

  // const onRemovePet = (index) => {
  //   const newPets = [...pets];
  //   newPets.splice(index, 1);
  //   setPets(newPets);
  // };

  return (
    <Row className="pets">
      <Col span={24}>
        <Card
          title="Pets"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row gutter={[0, 8]}>
              <Col span={23}>
                <Row gutter={[16, 0]}>
                  <Col span={24}>
                    <Row gutter={[8, 0]} >
                      <Col className="header-row" span={6}>
                        <span>Pet's Name</span>
                      </Col>
                      <Col className="header-row" span={7}>
                        <span>Type / Breed</span>
                      </Col>
                      <Col className="header-row" span={5}>
                        <span>Weight (lbs)</span>
                      </Col>
                      <Col className="header-row" span={5}>
                        <span>Age</span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              {pets.length >= 1 && pets ? pets.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row align="middle" gutter={[16, 0]}>
                      <Col span={23}>
                        <Row gutter={[8, 0]}>
                          <Col span={6}>
                            <Input placeholder="Name" value={item.name} onChange={(e)=>handleChange(e.target.value, "name", item.id)}/>
                          </Col>
                          <Col span={7}>
                            <Input placeholder="Type" value={item.type} onChange={(e)=>handleChange(e.target.value, "type", item.id)}/>
                          </Col>
                          <Col span={5}>
                            <Input placeholder="Weight" value={item.weight} onChange={(e)=>handleChange(e.target.value, "weight", item.id)}/>
                          </Col>
                          <Col span={5}>
                            <Select options={age} placeholder="Select..." value={item.age} onChange={(value)=>handleChange(value, "age", item.id)}/>
                          </Col>
                        </Row>
                      </Col>
                      {
                        pets.length > 1 ? <Col span={1}>
                        <CgCloseO
                          className="delete-btn"
                          size={20}
                          onClick={() => removePet(item.id)}
                        />
                      </Col> : null
                      }
                    </Row>
                  </Col>
                );
              }) : null}
              <Col span={24}>
                <button
                  onClick={() => addPet()}
                  className="add-icon-btn"
                >
                  <RiAddCircleFill size={18} />
                  <span>Add Another Pet</span>
                </button>
              </Col>
              <Col span={24} className="buttons-container">
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary" onClick={addPets}>Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row>
              {data?.pets?.length >= 1 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Row gutter={[8, 0]} className="header-row">
                        <Col span={6}>
                          <span>Pet's Name</span>
                        </Col>
                        <Col span={6}>
                          <span>Type / Breed</span>
                        </Col>
                        <Col span={5}>
                          <span>Weight (lbs)</span>
                        </Col>
                        <Col span={5}>
                          <span>Age</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {data?.pets.map((item, index) => {
                    return (
                      <Row gutter={[8, 0]} className="data-row" key={index}>
                        <Col span={6}>
                          <span>{item.name}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.type}</span>
                        </Col>
                        <Col span={5}>
                          <span>{item.weight}</span>
                        </Col>
                        <Col span={5}>
                          <span>{item.age}</span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>
                      <p>Click edit to add pets.</p>
                    </Col>
                  </Row>
                </Col>
              ) }
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default Pets;
